import TaxiService from '@/views/TaxiService/index.vue'

const TaxiServiceRouter = {
  path: '/taxi-service',
  name: 'TaxiService',
  component: TaxiService,
  props: (route) => ({
    secret: route.query.secret,
    indexBooking: route.query.indexBooking ? parseInt(route.query.indexBooking) : 0
  })
}

export default TaxiServiceRouter
